import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

// The response interceptor (api/dateConvertInterceptor.ts) turns every ISO date string in the
// response into a real Date, so this resolves to Date[] at runtime despite the JSON being strings.
const fetchDays = (courseId: number): AxiosPromise<Date[]> => {
  return api.get<Date[]>(endpoints.COURSES_ATTENDANCE.GET_DAYS(courseId));
};

// Backend `Day` is local midnight with Kind=Unspecified, not UTC — using toISOString() here would
// shift it by the timezone offset (e.g. a day back for Poland in summer). Send local Y/M/D instead.
export const toLocalIsoDate = (d: Date) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const fetch = (courseId: number, day: Date): AxiosPromise<CourseAttendanceApi> => {
  return api.get<CourseAttendanceApi>(endpoints.COURSES_ATTENDANCE.GET(courseId, toLocalIsoDate(day)));
};

export const courseAttendanceApi = {
  fetchDays,
  fetch,
};

export enum AttendanceStatusApi {
  Present = 1,
  Absent = 2,
}

export interface CourseAttendanceStudentApi {
  studentUserId: number;
  firstName: string;
  surname: string;
  status: AttendanceStatusApi | null;
}

export interface CourseAttendanceApi {
  courseId: number;
  day: Date;
  students: CourseAttendanceStudentApi[];
}
